export class VisibilityMapDto {
    constructor(initializer) {
        this.vendor = initializer.vendor;
        this.openApi = initializer.openApi;
        this.onlineContract = initializer.onlineContract;
        this.kiosk = initializer.kiosk;
        this.onlineCheckIn = initializer.onlineCheckIn;
    }
}
